import React from 'react';
import Alert, { AlertColor } from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';

interface Props {
  message: string;
  severity: AlertColor;
  onClose: () => void;
}

const Toast: React.FC<Props> = ({ message, severity, onClose }) => (
  <Snackbar
    open={!!message}
    autoHideDuration={4000}
    onClose={onClose}
    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
  >
    <Alert
      severity={severity}
      onClose={onClose}
      sx={{ width: '100%' }}
    >
      {message}
    </Alert>
  </Snackbar>
);

export default Toast;
